'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	GoldFileFilteredList = require('./gold-file-filtered-list'),
	pathInfoFromFileItem = require('./path-info-from-file-item'),
	commonFileListContext = require('./common-file-list-context'),
	asyncIterator = require('@mindmup/js-utils/src/async-iterator');
module.exports = function GoldFileListModel(goldFileListPreferences, fileModel, editorUrl, navigatorShim, optional) {
	if (!goldFileListPreferences || !fileModel || !editorUrl || !navigatorShim) {
		throw new Error('invalid-args');
	}
	let refreshingFileList = false, activatedFiles = [], allowedActions = [];
	const self = observable(this),
		goldFileFilteredList = (optional && optional.goldFileFilteredList) || new GoldFileFilteredList(goldFileListPreferences),
		canTrashFile = file => {
			return file && file.context && (file.context.myFile || file.context.teamFile);
		},
		canTrashActivatedFiles = () => {
			return !activatedFiles.find(file => !canTrashFile(file));
		},
		ensureActivatedFile = (filteredList) => {
			if (filteredList && filteredList.length) {
				const activatedFilesInFilteredList = activatedFiles.filter(file => {
					return filteredList.includes(file);
				});
				if (!activatedFilesInFilteredList.length) {
					const pageState = (optional && optional.pageState),
						defaultFileId = pageState && pageState.getFileId(),
						defaultFileUrl = defaultFileId && `_v2/${defaultFileId}`,
						candidates = (defaultFileUrl && filteredList.filter(file => file && file.url === defaultFileUrl)) || [];
					if (defaultFileUrl) {
						activatedFiles = candidates;
					} else {
						activatedFiles = [filteredList[0]];
					}
				} else {
					activatedFiles = activatedFilesInFilteredList;
				}
			} else {
				activatedFiles = [];
			}
		},
		buildContext = (currentAction) => {
			const listInfo = goldFileFilteredList.getCurrent(),
				currentPreferences = goldFileListPreferences.getPreferences(),
				filterType = currentPreferences && currentPreferences.filterType,
				isDefaultView = filterType === 'default',
				isTagFilter = Array.isArray(filterType),
				hasFilteredTags = listInfo && listInfo.filteredTags && listInfo.filteredTags.length,
				showUntaggedMapsHeader = !!(isDefaultView && listInfo.fileList.length && listInfo.tags.length),
				hasFiles = goldFileFilteredList.hasFiles(),
				showNoUntaggedMapsHeader =  isDefaultView && hasFiles && listInfo.tags.length && !showUntaggedMapsHeader;
			ensureActivatedFile(listInfo && listInfo.visibleFiles);
			return Object.assign({
				hasLegacyTeamFiles: goldFileFilteredList.hasLegacyTeamFiles(),
				showNoMapsMessage: listInfo.visibleFiles.length === 0,
				showTagFiltersHeader: !isDefaultView && isTagFilter,
				showUntaggedMapsHeader: showUntaggedMapsHeader,
				showNoUntaggedMapsHeader: showNoUntaggedMapsHeader,
				showNoTagsHeader: isDefaultView && hasFiles && !showUntaggedMapsHeader && !showNoUntaggedMapsHeader,
				canTrash: canTrashActivatedFiles(),
				filterType: filterType,
				currentAction: currentAction,
				activatedFiles: activatedFiles.slice(0),
				activatedFilesContext: commonFileListContext(activatedFiles),
				preferences: currentPreferences,
				showTagFilters: hasFilteredTags && (isDefaultView || isTagFilter)
			}, listInfo);
		},

		sendError = (error, handle) => {
			self.dispatchEvent('error', error);
			if (!handle) {
				throw error;
			}
		},
		sendContext = (currentAction) => {
			const context = buildContext(currentAction);
			self.dispatchEvent('context', context);
		},
		getFileList = () => {
			if (!allowedActions || !allowedActions.includes('ListGoldMaps')) {
				goldFileFilteredList.setFiles([]);
				sendContext();
				return Promise.resolve(goldFileFilteredList.getCurrentFilteredList());
			}
			sendContext('listingFiles');
			return fileModel.listFiles()
			.then((list) => {
				goldFileFilteredList.setFiles(list);
				sendContext();
				return goldFileFilteredList.getCurrentFilteredList();
			})
			.catch((error) => {
				if (error === 'action-not-allowed') {
					goldFileFilteredList.setFiles([]);
					sendContext();
					return goldFileFilteredList.getCurrentFilteredList();
				}
				sendContext();
				sendError(error, true);
			});
		},
		updateTagForFile = (action, file, tag) => {
			if (!action || !file || !tag) {
				return Promise.reject(new Error('invalid-args'));
			}
			const fileId = file.url.split('/')[1],
				pointerType = file.role === 'owner' ? 'pointer' : file.role;
			if (!pointerType) {
				return Promise.resolve();
			}
			return fileModel.updateTag(action, `${fileId}.${pointerType}`, tag)
			.then(() => ({file: file, tag: tag, changed: true}))
			.catch(reason => ({file: file, tag: tag, changed: false, error: reason}));
		},
		refreshList = (/*reason*/) => {
			goldFileFilteredList.recalculate();
			self.toggleContextMenuForFile();
		},
		selectFile = file => {
			const filtered = goldFileFilteredList.getCurrentFilteredList(),
				currentFile = activatedFiles[0];
			if (filtered && filtered.length && file && filtered.includes(file)) {
				self.dispatchEvent('toggleContextMenu');
				if (currentFile !== file) {
					activatedFiles = [file];
					sendContext();
				}
				return true;
			}

		},
		willShowEmptyTagList = () => {
			const currentPreferences = goldFileListPreferences.getPreferences(),
				filterType = currentPreferences && currentPreferences.filterType,
				isTagView = Array.isArray(filterType),
				listInfo = isTagView && goldFileFilteredList.getCurrent();
			return  !!(isTagView && !listInfo.filteredTags.length);
		};

	self.setAllowedActions = (newAllowedActions) => {
		allowedActions = newAllowedActions || [];
	};
	self.selectFile = (file) => selectFile(file);

	self.toggleActivatedFile = file => {
		if (activatedFiles.includes(file)) {
			activatedFiles = activatedFiles.filter(f => f !== file);
		} else {
			activatedFiles.push(file);
		}
		sendContext();
	};
	self.getActivatedFiles = () => activatedFiles.slice(0);

	self.load = () => {
		return getFileList()
		.then(filelist => {
			if (willShowEmptyTagList()) {
				self.setFilterDefault();
				return getFileList();
			}
			return filelist;
		});
	};
	self.refresh = () => {
		if (refreshingFileList) {
			return;
		}
		refreshingFileList = true;
		goldFileFilteredList.setFiles([]);
		sendContext('refreshingFiles');
		return fileModel.buildSavedList()
		.catch((error) => sendError(error, true))
		.then(() => getFileList())
		.then((fileList) => {
			refreshingFileList = false;
			return fileList;
		});
	};
	self.toggleContextMenuForFile = (file, position) => {
		if (!selectFile(file)) {
			return;
		}
		const canTrash = canTrashActivatedFiles(),
			size = file.context.recycleBin ? 'small' : 'medium';
		self.dispatchEvent('toggleContextMenu', Object.assign({size: size, position: position, canTrash: !!canTrash, description: file.description}, file.context));
	};

	self.tagsForFiles = files => {
		if (!files || !files.length) {
			return false;
		}
		const fileTags = {};
		goldFileFilteredList.getCurrentTags().forEach(tag => {
			const withtag = files.filter(file => {
				if (!file || !file.tags) {
					return false;
				}
				return file.tags.includes(tag);
			});
			if (!withtag.length) {
				fileTags[tag] = 'none';
			} else if (withtag.length === files.length) {
				fileTags[tag] = 'all';
			} else {
				fileTags[tag] = 'some';
			}
		});
		return fileTags;
	};

	self.addTagForFiles = (tag, files) => {
		if (!tag || !files || !Array.isArray(files)) {
			return Promise.reject(new Error('invalid-args'));
		}

		const errors = [];

		return asyncIterator(files, file => {
			if (file.tags && file.tags.includes(tag)) {
				return Promise.resolve();
			}
			return updateTagForFile('add', file, tag)
			.then(result => {
				if (result.error) {
					errors.push(result);
				}
				if (result.changed) {
					file.tags = file.tags || [];
					file.tags.push(tag);
					return fileModel.fileItemDecorator(file);
				}
			});
		})
		.then(() => {
			const currentTags = goldFileFilteredList.getCurrentTags(),
				isInverted = goldFileListPreferences.getListFilterInvert(),
				isDefault = goldFileListPreferences.getFilterType() === 'default',
				currentFilteredTags = goldFileFilteredList.getCurrentFilteredTags();
			if (isInverted || isDefault || !currentTags.includes(tag) || !currentFilteredTags.includes(tag)) {
				goldFileFilteredList.recalculate();
				sendContext();
			}
			if (errors.length) {
				// console.log('failed', errors);//eslint-disable-line
				throw errors[0];
			}
		});
	};
	self.removeTagForFiles = (tag, files) => {
		if (!tag || !files || !Array.isArray(files)) {
			return Promise.reject(new Error('invalid-args'));
		}
		const errors = [];
		return asyncIterator(files, file => {
			if (!file.tags || !file.tags.includes(tag)) {
				return Promise.resolve();
			}
			return updateTagForFile('remove', file, tag)
			.then(result => {
				if (result.error) {
					errors.push(result);
				}
				if (result.changed) {
					file.tags = file.tags || [];
					file.tags = file.tags.filter(cTag => cTag !== tag);
					return fileModel.fileItemDecorator(file);
				}
			});
		})
		.then(() => {
			goldFileFilteredList.recalculate();
			if (willShowEmptyTagList()) {
				self.setFilterDefault();
			} else {
				sendContext();
			}
			if (errors.length) {
				// console.log('failed', errors);//eslint-disable-line
				throw errors[0];
			}
		})
		;
	};

	self.getPreferedOpenType = () => goldFileListPreferences.getOpenType();

	self.setOpenInplacePreferred = () => {
		goldFileListPreferences.setOpenType('inplace');
		getFileList();
	};
	self.setOpenInNewTabPreferred = () => {
		goldFileListPreferences.setOpenType('newtab');
		getFileList();
	};

	self.getPreferedListType = () => goldFileListPreferences.getListType();


	self.setIconsListPreferred = () => {
		goldFileListPreferences.setListType('icons');
		sendContext();
	};
	self.setSimpleListPreferred = () => {
		goldFileListPreferences.setListType('list');
		sendContext();
	};
	self.setListSortType = (sortType) => {
		goldFileFilteredList.setListSortType(sortType);
		sendContext();
	};

	self.setFilterForTags = (tags) => {
		if (tags && tags.length) {
			goldFileFilteredList.setListFilterType(tags.map(tag => 'tag:' + tag));
		} else {
			goldFileFilteredList.setListFilterType('default');
		}
		sendContext();
	};

	self.setFilterForTag = (tag) => {
		if (tag) {
			goldFileFilteredList.setListFilterType('tag:' + tag);
		} else {
			goldFileFilteredList.setListFilterType('default');
		}
		sendContext();
	};
	self.setFilterMapsWithoutTags = () => {
		goldFileFilteredList.setListFilterInvert(true);
		sendContext();
	};
	self.setFilterMapsWithTags = () => {
		goldFileFilteredList.setListFilterInvert(false);
		sendContext();
	};
	self.setFilterCurrentFiles = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('allMaps');
		sendContext();
	};

	self.setFilterDefault = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('default');
		sendContext();
	};
	self.setFilterMyFiles = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('myFile');
		sendContext();
	};
	self.setFilterTeamFiles = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('teamFile');
		sendContext();
	};
	self.setFilterRecyleBin = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('recycleBin');
		sendContext();
	};
	self.setFilterSharedFiles = () => {
		goldFileFilteredList.setListFilterInvert(false);
		goldFileFilteredList.setListFilterType('sharedFile');
		sendContext();
	};
	self.setSortByNameAscending = () => {
		goldFileFilteredList.setListSortType('descriptionAscending');
		sendContext();
	};
	self.setSortByNameDescending = () => {
		goldFileFilteredList.setListSortType('descriptionDescending');
		sendContext();
	};
	self.setSortByMostRecent = () => {
		goldFileFilteredList.setListSortType('lastModifiedDescending');
		sendContext();
	};
	self.setSortByOldest = () => {
		goldFileFilteredList.setListSortType('lastModifiedAscending');
		sendContext();
	};
	self.getListSortType = () => {
		goldFileListPreferences.getSortType();
	};

	self.getCurrentList = () => goldFileFilteredList.getCurrentFilteredList();
	self.openSelectedMap = () => {
		activatedFiles.forEach(activatedFile => {
			if (activatedFiles.length === 1 && goldFileListPreferences.getOpenType() === 'inplace') {
				navigatorShim.redirect(editorUrl + '/' + activatedFile.url);
			} else {
				navigatorShim.open(editorUrl + '/' + activatedFile.url);
			}

		});
	};

	self.openSelectedMapHistory = () => {
		activatedFiles.forEach(activatedFile => {
			const fileId = activatedFile.url.split('/')[1];
			if (activatedFiles.length === 1 && goldFileListPreferences.getOpenType() === 'inplace') {
				navigatorShim.redirect('/history.html?fileId=' + fileId);
			} else {
				navigatorShim.open('/history.html?fileId=' + fileId);
			}
		});
	};
	self.copySelectedMap = () => {
		activatedFiles.forEach(activatedFile => {
			navigatorShim.open(editorUrl + '/' + activatedFile.url + '?intent=copyFile');
		});
	};

	self.trashSelectedMap = () => {

		self.dispatchEvent('trashing');
		return Promise.all(activatedFiles.map(activatedFile => {
			const pathInfo = pathInfoFromFileItem(activatedFile);
			if (pathInfo.version === 1) {
				navigatorShim.open(editorUrl + '/' + activatedFile.url + '?intent=trashFile');
				return Promise.resolve();
			}
			return fileModel.deleteFileListItem(pathInfo)
			.then(() => {
				activatedFile.trashTs = Math.floor(Date.now() / 1000);
				return fileModel.fileItemDecorator(activatedFile);
			});
		}))
		.then(refreshList)
		.then(sendContext)
		.catch(() => self.dispatchEvent('error', 'trashing'));
	};
	self.untrashSelectedMap = () => {
		self.dispatchEvent('untrashing');
		return Promise.all(activatedFiles.map(activatedFile => {
			const pathInfo = pathInfoFromFileItem(activatedFile);
			if (pathInfo.version === 1) {
				navigatorShim.open(editorUrl + '/' + activatedFile.url + '?intent=trashFile');
				return Promise.resolve();
			}
			return fileModel.undeleteFileListItem(pathInfo)
			.then(() => {
				delete activatedFile.trashTs;
				return fileModel.fileItemDecorator(activatedFile);
			});
		}))
		.then(refreshList)
		.then(sendContext)
		.catch(() => self.dispatchEvent('error', 'untrashing'));
	};
	self.ensureReady = () => {
		if (activatedFiles[0] && goldFileFilteredList.hasFiles()) {
			return Promise.resolve(goldFileFilteredList.getCurrentFilteredList());
		}
		return getFileList();
	};
};
